import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-eb4dc30a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["id", "data-cy"];
var _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_close_icon = _resolveComponent("close-icon");
  var _component_base_button = _resolveComponent("base-button");
  return _openBlock(), _createBlock(_Teleport, {
    to: "body"
  }, [_createElementVNode("div", {
    ref: "backdropEl",
    "class": _normalizeClass(["bbt-backdrop tw-fixed tw-w-full tw-h-full tw-left-0 tw-top-0 tw-start-0 tw-flex tw-justify-center tw-overflow-y-auto tw-items-start tw-px-0 tw-pt-0 sm:tw-px-5 sm:tw-pt-[30px]", [_ctx.customBackdropClasses]]),
    style: {
      "z-index": "1062"
    },
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.closeOnBackdropClick && _ctx.closeOnBackdropClick.apply(_ctx, arguments);
    })
  }, [_createElementVNode("dialog", {
    id: _ctx.id,
    ref: "modalEl",
    "data-cy": _ctx.$attrs['data-cy'],
    "class": _normalizeClass(["custom-modal tw-block tw-no-scrollbar safe-bottom base-bt-modal tw-m-0 tw-p-0 !tw-relative tw-w-full transition-y tw-bg-transparent tw-border-none tw-overflow-x-hidden tw-overflow-y-hidden max-sm:tw-rounded-br-none max-sm:tw-rounded-bl-none tw-rounded max-sm:tw-fixed tw-h-full sm:tw-h-auto max-sm:tw-max-w-full max-sm:tw-w-full max-sm:tw-border-0", [_ctx.customModalClasses]])
  }, [_createElementVNode("div", {
    "class": _normalizeClass(["bbt-modal-wrapper tw-h-full tw-relative", [_ctx.customModalDialogClasses]])
  }, [_createElementVNode("div", {
    "class": _normalizeClass(["tw-modal-content tw-no-scrollbar sm:tw-flex sm:tw-flex-col sm:tw-shadow-[0_3px_6px_#00000029] sm:tw-relative tw-rounded tw-bg-white sm:tw-overflow-y-auto sm:tw-py-0 tw-max-h-[90%] tw-overflow-x-hidden tw-w-full tw-h-auto tw-fixed tw-py-0 max-sm:tw-rounded-br-none max-sm:tw-rounded-bl-none tw-bottom-0", [_ctx.customModalContentClasses, 'transition-y', {
      'full-height-mobile': _ctx.fullHeight
    }]])
  }, [_createElementVNode("div", {
    "class": _normalizeClass(["tw-border-0 default-header tw-px-4 sm:tw-px-6", [_ctx.customModalHeaderClasses]])
  }, [_ctx.withCloseIcon ? (_openBlock(), _createBlock(_component_base_button, {
    key: 0,
    id: "close-icon-btn",
    "data-cy": "bbt-default-close-icon-btn",
    "class": _normalizeClass(["tw-z-10 tw-bg-transparent", _ctx.$attrs['close-icon-btn-classes']]),
    type: "button",
    "aria-label": "Close",
    "is-empty": true,
    onClick: _withModifiers(_ctx.closeModal, ["prevent", "stop"])
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_close_icon, {
        "class": "tw-p-5px bbt-close-icon",
        width: 30,
        height: 30
      })];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "onClick"])) : _createCommentVNode("v-if", true), _renderSlot(_ctx.$slots, "header", {
    closeModal: _ctx.closeModal
  }, function () {
    return [_createElementVNode("span", {
      "class": _normalizeClass(["tw-text-18 sm:tw-text-22 tw-font-semibold tw-w-auto", _ctx.$attrs['title-classes']]),
      innerHTML: _ctx.headerTitle
    }, null, 10 /* CLASS, PROPS */, _hoisted_2)];
  }, true)], 2 /* CLASS */), _createElementVNode("div", {
    "class": _normalizeClass(["tw-bbt-body tw-px-4 sm:tw-px-6 tw-pb-0 sm:tw-pb-25px tw-flex-auto tw-overflow-y-auto tw-overflow-x-hidden tw-no-scrollbar", [_ctx.customModalBodyClasses]])
  }, [_renderSlot(_ctx.$slots, "body", {}, undefined, true)], 2 /* CLASS */), _ctx.withCustomFooter ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": _normalizeClass(["tw-bbt-footer tw-px-4 sm:tw-px-6 tw-bg-white tw-border-0 tw-py-15px", _ctx.customModalFooterClasses])
  }, [_renderSlot(_ctx.$slots, "footer", {
    closeModal: _ctx.closeModal
  }, undefined, true)], 2 /* CLASS */)) : _createCommentVNode("v-if", true)], 2 /* CLASS */)], 2 /* CLASS */), _renderSlot(_ctx.$slots, "fixed-bottom", {}, undefined, true)], 10 /* CLASS, PROPS */, _hoisted_1)], 2 /* CLASS */)]);
}